// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputPoint_inputContainer__o8QP3","pointInput":"InputPoint_pointInput__yIbGJ","spanP":"InputPoint_spanP__l9QWX"};